import { ProductLineName } from "../../models/products/collection";

// Models that only support grommet rib attachments, regardless of collection handle.
// This check takes priority over the collection-level pockets/grommets logic.
export const grommetOnlyModels: string[] = [
  "864FM-SQ",
  "864FMC-SQ",
  "864FMA-SQ",
  "882FMC-R",
  "876FMA-R"
];

export const ribAttachment: { pockets: string[]; grommets: string[] } = {
  pockets: [
    ProductLineName.MontereyPulleyLift,
    ProductLineName.MontereyAutoTilt,
    ProductLineName.MontereyCrank,
    ProductLineName.Greenwich,
    ProductLineName.Catalina,
    ProductLineName.Avalon
  ],
  grommets: [
    ProductLineName.Greenwich,
    ProductLineName.MontereyPulleyLift,
    ProductLineName.MontereyAutoTilt,
    ProductLineName.MontereyCrank,
    ProductLineName.GreenwichGSeries,
    ProductLineName.MontereyGSeries,
    ProductLineName.Eclipse,
    ProductLineName.Aurora
  ]
  // Laurel & Emerald Coast have no attachments
};
